export {DialogContent, dialogContentStyles} from './dialog-content'
